// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"430":"f86da811","453":"d6d6209f","472":"48a3f0bd","892":"124d0d51"}[chunkId] + ".chunk.js";
};